import { axiosInstance } from "@/composables/api.js";
import { decode } from "jsonwebtoken-esm";

function setToken(token, token_name, token_obj) {
  token_obj.value = decode(token);
  localStorage.setItem(token_name, token);
  axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

function removeToken(token_name, token_obj) {
  token_obj.value = false;
  localStorage.removeItem(token_name);
  delete axiosInstance.defaults.headers.common["Authorization"];
}

export { setToken, removeToken };
